import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();
  const bullets = ["home.aboutB1", "home.aboutB2", "home.aboutB3", "home.aboutB4"];

  return (
    <section className="px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{t("home.aboutTitle")}</h2>
          <p className="mt-5 text-foreground-600 leading-relaxed">{t("home.aboutP1")}</p>
          <p className="mt-4 text-foreground-600 leading-relaxed">{t("home.aboutP2")}</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200 p-6 md:p-8">
          <ul className="space-y-4">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </span>
                <span className="text-sm text-foreground-700">{t(b)}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}